import { isConfigSettled, useConfigSelection } from '@leagueplatform/core';

const defaultConfig = {
  showAccountBanner: true,
  showOptionsMenu: true,
  healthReportMasonryId: undefined,
  showLandingPageBackButton: undefined,
  disableDevicesInMoreOptionsMenu: false,
};

export const useAboutMeConfig = () =>
  useConfigSelection(
    (config) =>
      isConfigSettled(config)
        ? {
            showAccountBanner:
              config.config['flag_about-me_show-account-banner'],
            showOptionsMenu: config.config['flag_about-me_show-options-menu'],
            healthReportMasonryId:
              config.config['config_about-me_health-report-masonry-id'],
            showLandingPageBackButton:
              config.config['flag_about-me_show-landing-page-back-button'],
            disableDevicesInMoreOptionsMenu:
              config.config.config_about_me_disable_devices_menu_option,
          }
        : {},
    defaultConfig,
  );
